module.exports = __webpack_public_path__ + "img/image4.1e6063e7.png";